import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export const CostCalculatorFailureNotice = ({
  audience = 'employer',
}: {
  audience?: 'employer' | 'provider';
}) => (
  <div
    role="status"
    className="rounded-control border border-error-t-600 bg-error-t-900 p-4 text-error-300"
  >
    <div className="flex items-start gap-3">
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-error-t-900">
        <ExclamationTriangleIcon className="size-5 text-error-50" aria-hidden="true" />
      </div>
      <div>
        <h3 className="text-sm font-semibold">
          {audience === 'employer'
            ? "We couldn't calculate this cost analysis"
            : 'Cost analysis unavailable'}
        </h3>
        <p className="mt-1 text-sm">
          {audience === 'employer'
            ? 'Your compensation and shift details were saved. Submit again to retry the calculation, or contact support if this keeps happening.'
            : "This listing's complete compensation summary is temporarily unavailable."}
        </p>
      </div>
    </div>
  </div>
);
